export enum CurrencyPosition {
    Left,
    Right,
}

export interface MarketplaceI {
    marketplace_id: string
    currency_code: string
    country_code: string
    timezone: string
    currency_symbol: string
    currency_position: CurrencyPosition
    domain: string
}

interface MarketplacesI {
    [Marketplace.UnitedStates]: MarketplaceI
    [Marketplace.Canada]: MarketplaceI
    [Marketplace.Mexico]: MarketplaceI
    [Marketplace.Brazil]: MarketplaceI

    [Marketplace.UnitedKingdom]: MarketplaceI
    [Marketplace.Germany]: MarketplaceI
    [Marketplace.France]: MarketplaceI
    [Marketplace.Spain]: MarketplaceI
    [Marketplace.Italy]: MarketplaceI
    [Marketplace.Netherlands]: MarketplaceI
    [Marketplace.Sweden]: MarketplaceI
    [Marketplace.Belgium]: MarketplaceI
    [Marketplace.Poland]: MarketplaceI
    [Marketplace.Egypt]: MarketplaceI
    [Marketplace.Turkey]: MarketplaceI
    [Marketplace.SaudiArabia]: MarketplaceI
    [Marketplace.UAE]: MarketplaceI
    [Marketplace.India]: MarketplaceI
    [Marketplace.Ireland]: MarketplaceI
    [Marketplace.SouthAfrica]: MarketplaceI

    [Marketplace.Japan]: MarketplaceI
    [Marketplace.Australia]: MarketplaceI
    [Marketplace.Singapore]: MarketplaceI
}

export enum Marketplace {
    UnitedStates = 'ATVPDKIKX0DER',
    Canada = 'A2EUQ1WTGCTBG2',
    Mexico = 'A1AM78C64UM0Y8',
    Brazil = 'A2Q3Y263D00KWC',

    UnitedKingdom = 'A1F83G8C2ARO7P',
    Germany = 'A1PA6795UKMFR9',
    France = 'A13V1IB3VIYZZH',
    Spain = 'A1RKKUPIHCS9HS',
    Italy = 'APJ6JRA9NG5V4',
    Netherlands = 'A1805IZSGTT6HS',
    Sweden = 'A2NODRKZP88ZB9',
    Belgium = 'AMEN7PMS3EDWL',
    Poland = 'A1C3SOZRARQ6R3',
    Egypt = 'ARBP9OOSHTCHU',
    Turkey = 'A33AVAJ2PDY3EV',
    SaudiArabia = 'A17E79C6D8DWNP',
    UAE = 'A2VIGQ35RCS4UG',
    India = 'A21TJRUUN4KGV',
    Ireland = 'A28R8C7NBKEWEA',
    SouthAfrica = 'AE08WJ6YKNBMC',

    Japan = 'A1VC38T7YXB528',
    Australia = 'A39IBJ37TRP1C6',
    Singapore = 'A19VAU5U5O7RUS',
}

export enum Timezones {
    LosAngeles = 'America/Los_Angeles',
    SaoPaulo = 'America/Sao_Paulo',
    London = 'Europe/London',
    Paris = 'Europe/Paris',
    Tokyo = 'Asia/Tokyo',
    Dubai = 'Asia/Dubai',
    Sydney = 'Australia/Sydney',
    Stockholm = 'Europe/Stockholm',
    Amsterdam = 'Europe/Amsterdam',
    Kolkata = 'Asia/Kolkata',
    Istanbul = 'Europe/Istanbul',
    Warsaw = 'Europe/Warsaw',
    Brussels = 'Europe/Brussels',
    Cairo = 'Africa/Cairo',
    Riyadh = 'Asia/Riyadh',
    Singapore = 'Asia/Singapore',
    Johannesburg = 'Africa/Johannesburg',
    Dublin = 'Europe/Dublin',
}

export const Marketplaces: MarketplacesI = {
    [Marketplace.UnitedStates]: {
        marketplace_id: Marketplace.UnitedStates,
        currency_code: 'USD',
        country_code: 'US',
        timezone: Timezones.LosAngeles,
        currency_symbol: '$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com',
    },
    [Marketplace.Canada]: {
        marketplace_id: Marketplace.Canada,
        currency_code: 'CAD',
        country_code: 'CA',
        timezone: Timezones.LosAngeles,
        currency_symbol: '$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.ca',
    },
    [Marketplace.Mexico]: {
        marketplace_id: Marketplace.Mexico,
        currency_code: 'MXN',
        country_code: 'MX',
        timezone: Timezones.LosAngeles,
        currency_symbol: '$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.mx',
    },
    [Marketplace.Brazil]: {
        marketplace_id: Marketplace.Brazil,
        currency_code: 'BRL',
        country_code: 'BR',
        timezone: Timezones.SaoPaulo,
        currency_symbol: 'R$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.br',
    },

    [Marketplace.UnitedKingdom]: {
        marketplace_id: Marketplace.UnitedKingdom,
        currency_code: 'GBP',
        country_code: 'UK',
        timezone: Timezones.London,
        currency_symbol: '£',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.co.uk',
    },
    [Marketplace.Germany]: {
        marketplace_id: Marketplace.Germany,
        currency_code: 'EUR',
        country_code: 'DE',
        timezone: Timezones.Paris,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.de',
    },
    [Marketplace.France]: {
        marketplace_id: Marketplace.France,
        currency_code: 'EUR',
        country_code: 'FR',
        timezone: Timezones.Paris,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.fr',
    },
    [Marketplace.Spain]: {
        marketplace_id: Marketplace.Spain,
        currency_code: 'EUR',
        country_code: 'ES',
        timezone: Timezones.Paris,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.es',
    },
    [Marketplace.Italy]: {
        marketplace_id: Marketplace.Italy,
        currency_code: 'EUR',
        country_code: 'IT',
        timezone: Timezones.Paris,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.it',
    },
    [Marketplace.Netherlands]: {
        marketplace_id: Marketplace.Netherlands,
        currency_code: 'EUR',
        country_code: 'NL',
        timezone: Timezones.Paris,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.nl',
    },
    [Marketplace.Sweden]: {
        marketplace_id: Marketplace.Sweden,
        currency_code: 'SEK',
        country_code: 'SE',
        timezone: Timezones.Stockholm,
        currency_symbol: ' kr',
        currency_position: CurrencyPosition.Right,
        domain: 'amazon.se',
    },
    [Marketplace.Belgium]: {
        marketplace_id: Marketplace.Belgium,
        currency_code: 'EUR',
        country_code: 'BE',
        timezone: Timezones.Brussels,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.be',
    },
    [Marketplace.Poland]: {
        marketplace_id: Marketplace.Poland,
        currency_code: 'PLN',
        country_code: 'PL',
        timezone: Timezones.Warsaw,
        currency_symbol: 'zł',
        currency_position: CurrencyPosition.Right,
        domain: 'amazon.pl',
    },
    [Marketplace.Egypt]: {
        marketplace_id: Marketplace.Egypt,
        currency_code: 'EGP',
        country_code: 'EG',
        timezone: Timezones.Cairo,
        currency_symbol: 'E£',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.eg',
    },
    [Marketplace.Turkey]: {
        marketplace_id: Marketplace.Turkey,
        currency_code: 'TRY',
        country_code: 'TR',
        timezone: Timezones.Istanbul,
        currency_symbol: '₺',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.tr',
    },
    [Marketplace.SaudiArabia]: {
        marketplace_id: Marketplace.SaudiArabia,
        currency_code: 'SAR',
        country_code: 'SA',
        timezone: Timezones.Riyadh,
        currency_symbol: 'SAR ',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.sa',
    },
    [Marketplace.UAE]: {
        marketplace_id: Marketplace.UAE,
        currency_code: 'AED',
        country_code: 'AE',
        timezone: Timezones.Dubai,
        currency_symbol: 'AED ',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.ae',
    },
    [Marketplace.India]: {
        marketplace_id: Marketplace.India,
        currency_code: 'INR',
        country_code: 'IN',
        timezone: Timezones.Kolkata,
        currency_symbol: '₹',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.in',
    },
    [Marketplace.Ireland]: {
        marketplace_id: Marketplace.Ireland,
        currency_code: 'EUR',
        country_code: 'IE',
        timezone: Timezones.Dublin,
        currency_symbol: '€',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.ie',
    },
    [Marketplace.SouthAfrica]: {
        marketplace_id: Marketplace.SouthAfrica,
        currency_code: 'ZAR',
        country_code: 'ZA',
        timezone: Timezones.Johannesburg,
        currency_symbol: 'R',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.co.za',
    },

    [Marketplace.Japan]: {
        marketplace_id: Marketplace.Japan,
        currency_code: 'JPY',
        country_code: 'JP',
        timezone: Timezones.Tokyo,
        currency_symbol: '¥',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.co.jp',
    },
    [Marketplace.Australia]: {
        marketplace_id: Marketplace.Australia,
        currency_code: 'AUD',
        country_code: 'AU',
        timezone: Timezones.Sydney,
        currency_symbol: '$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.au',
    },
    [Marketplace.Singapore]: {
        marketplace_id: Marketplace.Singapore,
        currency_code: 'SGD',
        country_code: 'SG',
        timezone: Timezones.Singapore,
        currency_symbol: 'S$',
        currency_position: CurrencyPosition.Left,
        domain: 'amazon.com.sg',
    },
}

export enum MarketplaceInt {
    UnitedStates = 1,
    UnitedKingdom = 2,
    Germany = 3,
    France = 4,
    Japan = 5,
    Canada = 6,
    Italy = 8,
    Spain = 9,
    India = 10,
    Mexico = 11,
    Brazil = 51,
    UAE = 52,
    Egypt = 53,
    Netherlands = 54,
    SaudiArabia = 55,
    Sweden = 56,
    Turkey = 57,
    Singapore = 58,
    Australia = 59,
    Belgium = 60,
    Poland = 61,
    Ireland = 62,
    SouthAfrica = 63,
}
